import { CandidateItem } from "../candidateItem"
import { LoadingComponent } from "../loading"
import { CandidateListProps } from "./model"

export const CandidatesList = (candidatesProps: CandidateListProps) => {
    const candidatesWithUrl =
        candidatesProps.candidates?.map((candidate) => ({
            ...candidate,
            url: candidatesProps.url,
        })) || []

    return (
        <div className="w-full">
            {candidatesProps.loading ? (
                <LoadingComponent />
            ) : candidatesWithUrl.length > 0 ? (
                candidatesWithUrl.map((candidateProps) => (
                    <div key={candidateProps.id} className="mb-4 w-full">
                        <CandidateItem props={candidateProps} />
                    </div>
                ))
            ) : (
                <p className="text-figmaDarkGray text-[14px] text-center mt-[32px]">
                    {candidatesProps.emptyMessage ?? "Nu există candidați."}
                </p>
            )}
        </div>
    )
}